<div class="interactives">
    <section class="filters">
        <div class="pills">
            @for (pill of statusPills; track pill.value) {
                <button
                    type="button"
                    class="pill"
                    [class.is-active]="selectedStatus() === pill.value"
                    (click)="selectStatus(pill.value)"
                >
                    {{ pill.label }}
                </button>
            }
        </div>

        <div class="dropdowns">
            <mat-form-field appearance="outline" class="filter-select">
                <mat-select
                    [value]="selectedType()"
                    (selectionChange)="onTypeChange($event.value)"
                >
                    @for (option of typeOptions; track option.value) {
                        <mat-option [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-select tenant">
                <mat-select
                    [value]="selectedTenantId()"
                    (selectionChange)="onTenantChange($event.value)"
                >
                    <mat-option value="ALL">All Tenants</mat-option>
                    @for (tenant of tenants(); track tenant.id) {
                        <mat-option [value]="tenant.id">
                            {{ tenant.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Marketers have read-only access -->
        @if (!isMarketer()) {
            <tools-button routerLink="new">Create New Interactive</tools-button>
        }
    </section>

    @if (isLoading()) {
        <div class="loading status"></div>
    } @else if (items().length === 0) {
        <section class="empty" aria-label="Empty state">
            <h3>No Match</h3>
            <h5>
                Try changing your filters or clearing them to see more
                interactives.
            </h5>
        </section>
    } @else {
        <ul class="results">
            @for (item of items(); track item.id) {
                <app-interactive-list-result
                    [item]="item"
                    (stateChanged)="onStateChanged($event, item)"
                />
            }
        </ul>
        <tools-paginator
            class="pagination"
            [variant]="paginatorVariant"
            [length]="totalItems()"
            [pageSize]="pageSize()"
            [pageIndex]="pageIndex()"
            (page)="onPageChange($event)"
        ></tools-paginator>
    }
</div>
